import { FC, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { completeWorkItems } from "../../redux/apis/blenderApiSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { selectAuth } from "../../redux/slices/authSlice";
import AgentStatePanelPresenter from "../presenters/agent/AgentStatePanelPresenter";
import WorkItemPanelPresenter from "../presenters/work-item/WorkItemPanelPresenter";

interface IProps {}

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${(props) => props.theme.primary};
  filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04))
    drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  border-radius: 0.25rem;
`;

const PanelsContainer: FC<IProps> = () => {
  const dispatch = useAppDispatch();
  const { token } = useSelector(selectAuth);
  
  const { agentProperties, workItems } = useAppSelector(
    (state) => state.blenderState.agentClientState
  );
  const { selectedWorkItemId } = useAppSelector(
    (state) => state.consolePageState
  );

  const cancelWorkItem = useCallback(() => {
    dispatch(
      completeWorkItems(
        {
          workItemId: selectedWorkItemId,
          notes: "Automatically closed",
          closureCode: "Cancelled",
        },
        token
      )
    );
  }, [dispatch, selectedWorkItemId, token]);

  const workItemPresenters = useMemo(() => {
    if (!workItems) return <></>;
    return Object.values(workItems).map((workItem) => (
      <WorkItemPanelPresenter
        workItem={workItem}
        key={workItem.workItemId}
        selectedWorkItemId={selectedWorkItemId}
        cancelWorkItem={cancelWorkItem}
      />
    ));
  }, [cancelWorkItem, selectedWorkItemId, workItems]);

  return (
    <RootContainer>
      {agentProperties.state === "Busy" || agentProperties.state === "PendingLogout" || agentProperties.state === "PendingBreak" ? (
        workItemPresenters
      ) : (
        <AgentStatePanelPresenter agentProperties={agentProperties} />
      )}
    </RootContainer>
  );
};

export default PanelsContainer;
